// Rounds management module for PPT Hero game
export default class RoundsManager {
  constructor(scene) {
    this.scene = scene;
  }

  // Get rounds definition
  getRoundsDefinition() {
    return [
      {
        id: 'practice',
        name: 'Practice',
        description: 'Free practice mode with no time limits',
        levels: [0],
        unlocked: true
      },
      {
        id: 'calibration',
        name: 'Calibration Round',
        description: 'Establish your baseline performance (Levels 1-10)',
        levels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        unlocked: true
      },
      {
        id: 'basic',
        name: 'Basic Round',
        description: 'Fundamental PowerPoint shortcuts (Levels 1-10)',
        levels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        unlocked: true
      },
      {
        id: 'advanced',
        name: 'Advanced Round',
        description: 'Advanced PowerPoint techniques (Levels 16-20)',
        levels: [16, 17, 18, 19, 20],
        unlocked: true
      }
    ];
  }

}
